import React from 'react';
import LargeWidthContainer from '../../../Layout/Containers/LargeWidthContainer';
import { StrapiCoverImageComponent } from '../../MediaComponent/MediaComponent';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import Link from 'next/link';
import styles from './renderSolution.module.scss';
import RelatedSolutionsComponentRender from '../../../RelatedSolutions/RelatedSolutionsComponentRender';
import { solutionsData } from '../../../Solutions/solutionsData';
import { SingleSolutionPageProps } from '../../../Models/PageProps';
import InsuranceContactComponent from '../../../Contact/InsuranceContactComponent';
import SolutionCards from '../SolutionCards/SolutionCards';
import RelatedArticlesComponent from '../../../RelatedArticles/RelatedArticlesComponent';

const RenderCoverImageSection = ({ coverImage }: any) => {
    if (!coverImage) {
        return null;
    }
    return (
        <LargeWidthContainer>
            <StrapiCoverImageComponent
                strapiImage={coverImage.picture}
                styles={{ width: '100%', height: '476px' }}
                className={styles.fullCoverImage}
            >
                <div className={styles.cover}>
                    <BlocksRenderer content={coverImage.paragraph}></BlocksRenderer>
                    <div className={styles.links}>
                        <Link
                            href="#contact-banner"
                            className={'button-link-inverted'}
                            scroll={false}
                        >
                            <span>Contact us &#10132;</span>
                        </Link>
                    </div>
                </div>
            </StrapiCoverImageComponent>
        </LargeWidthContainer>
    );
};

const RenderIntroductionSection = ({ introduction }: any) => {
    if (!introduction) {
        return null;
    }
    return (
        <LargeWidthContainer>
            <div className={styles.introduction}>
                <BlocksRenderer content={introduction.paragraph}></BlocksRenderer>
            </div>
        </LargeWidthContainer>
    );
};

const RenderSolution = ({
    page,
    solutionKey,
    children,
    solutions,
    relatedArticles,
}: SingleSolutionPageProps) => {
    if (!page) {
        return null;
    } else {
        return (
            <>
                {children}
                <RenderCoverImageSection coverImage={page['coverImage']}></RenderCoverImageSection>
                <RenderIntroductionSection
                    introduction={page['introduction']}
                ></RenderIntroductionSection>
                <SolutionCards solutions={solutions}></SolutionCards>
                <div id="contact-banner" className={styles.contact}>
                    <InsuranceContactComponent />
                </div>
                <LargeWidthContainer>
                    <RelatedSolutionsComponentRender
                        solutions={solutionsData}
                        currentSolutionKey={solutionKey}
                    ></RelatedSolutionsComponentRender>
                </LargeWidthContainer>
                <RelatedArticlesComponent articles={relatedArticles}></RelatedArticlesComponent>
            </>
        );
    }
};

export default RenderSolution;
